import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f0388be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }

import { Toaster } from '@/common/Toaster'
import { __ } from '@/locales'
import { PLAYER_STATES } from '@/model/Player'
import router, { goTo } from '@/router'
import { useStoreAuth } from '@/store/auth'
import { useStoreGame } from '@/store/game'
import { computed, ref } from 'vue'

import GameContainer from '@/components/game/basics/GameContainer.vue'
import GamePlayerCreated from '@/components/game/home/GamePlayerCreated.vue'
import GamePlayerStarted from '@/components/game/home/GamePlayerStarted.vue'
import GamePlayerCompleted from '@/components/game/home/GamePlayerCompleted.vue'
import GamePlayerTerminated from '@/components/game/home/GamePlayerTerminated.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewHome',
  setup(__props) {

const storeAuth = useStoreAuth()
const storeGame = useStoreGame()

const loadingStart = ref(false)

const player = computed(() => storeGame.player)
const answers = computed(() => storeGame.answers)
const journey = computed(() => storeGame.journey)

const completedAnswers = computed(() =>
  answers.value.filter((a) => a.completed),
)

const projectLogo = computed(() => {
  return storeGame.project?.base64
})

const logout = () => {
  goTo({ name: 'Login', query: { username: storeAuth.user?.username } })
  storeAuth.logout()
}

const start = async (alternative: boolean) => {
  loadingStart.value = true
  const response = await storeGame.start(alternative)
  loadingStart.value = false
  if (response.success) {
    router.push({ name: 'Begin' })
  } else {
    Toaster.toast(response)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_base_reload_data = _resolveComponent("base-reload-data")!

  return (_openBlock(), _createBlock(GameContainer, { class: "start" }, {
    default: _withCtx(() => [
      (!_unref(player) || !_unref(journey))
        ? (_openBlock(), _createBlock(_component_base_reload_data, { key: 0 }))
        : _createCommentVNode("", true),
      (_unref(player) && _unref(journey))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_unref(player).state === _unref(PLAYER_STATES).CREATED)
              ? (_openBlock(), _createBlock(GamePlayerCreated, {
                  key: 0,
                  player: _unref(player),
                  journey: _unref(journey),
                  projectImage: _unref(projectLogo),
                  loadingStart: loadingStart.value,
                  onStart: _cache[0] || (_cache[0] = ($event: any) => (start($event)))
                }, null, 8, ["player", "journey", "projectImage", "loadingStart"]))
              : _createCommentVNode("", true),
            (_unref(player).state === _unref(PLAYER_STATES).STARTED)
              ? (_openBlock(), _createBlock(GamePlayerStarted, {
                  key: 1,
                  player: _unref(player),
                  journey: _unref(journey),
                  completedAnswersCount: _unref(completedAnswers).length,
                  totalAnswersCount: _unref(answers).length,
                  onPlay: _cache[1] || (_cache[1] = ($event: any) => (_unref(goTo)({ name: 'Play' }))),
                  onLogout: _cache[2] || (_cache[2] = ($event: any) => (logout()))
                }, null, 8, ["player", "journey", "completedAnswersCount", "totalAnswersCount"]))
              : _createCommentVNode("", true),
            (_unref(player).state === _unref(PLAYER_STATES).COMPLETED)
              ? (_openBlock(), _createBlock(GamePlayerCompleted, {
                  key: 2,
                  player: _unref(player),
                  journey: _unref(journey),
                  onLogout: _cache[3] || (_cache[3] = ($event: any) => (logout())),
                  onEnd: _cache[4] || (_cache[4] = ($event: any) => (_unref(goTo)({ name: 'End' })))
                }, null, 8, ["player", "journey"]))
              : _createCommentVNode("", true),
            (_unref(player).state === _unref(PLAYER_STATES).TERMINATED)
              ? (_openBlock(), _createBlock(GamePlayerTerminated, {
                  key: 3,
                  player: _unref(player),
                  journey: _unref(journey),
                  onLogout: _cache[5] || (_cache[5] = ($event: any) => (logout()))
                }, null, 8, ["player", "journey"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})